// extracted by mini-css-extract-plugin
module.exports = {"actionText":"styles_actionText__1B5iG"};